define([
    "jquery",
    "underscore",
    "marionette",
    "datatables",
    "bootstrap.datepicker",
], function ($, _, Marionette) {
    return Marionette.View.extend({
        el: "#content_layout",

        ui: {
            cancelWithdrawalButtons: ".cancel_withdrawal_button",
            cancelTransferButtons: ".cancel_transfer_button",
            datatables: "#datatables",
            selectedAccount: "#selected_account",
            startDatepicker: "#datetimepicker_start",
            endDatepicker: "#datetimepicker_end",
            startDate: "#start_date",
            endDate: "#end_date",
            filterDates: "#filer_dates",
        },

        events: {
            "click @ui.cancelWithdrawalButtons": function (e) {
                var that = this;
                if (e) e.preventDefault();

                // Get the CD from the TR's data-cd parameter.
                var cd = $(e.currentTarget).parents("tr").data("cd");
                $.ajax({
                    url: baseUrl + "/rest_account/cancel_withdrawal",
                    method: "POST",
                    data: {
                        cd: cd,
                    },
                    success: function () {
                        // Reload the table for the new status, keep the current pagination so the updated record
                        // Is still visible.
                        that.datatables.ajax.reload(null, false);
                    },
                    error: function (jqXHR, textStatus, error) {
                        alert(jqXHR.responseText);
                    },
                });
            },
            "click @ui.cancelTransferButtons": function (e) {
                var that = this;
                if (e) e.preventDefault();

                // Get the CD from the TR's data-cd parameter.
                var cd = $(e.currentTarget).parents("tr").data("cd");
                $.ajax({
                    url: baseUrl + "/rest_account/cancel_internal_transfer",
                    method: "POST",
                    data: {
                        cd: cd,
                    },
                    success: function () {
                        // Reload the table for the new status, keep the current pagination so the updated record
                        // Is still visible.
                        that.datatables.ajax.reload(null, false);
                    },
                    error: function (jqXHR, textStatus, error) {
                        alert(jqXHR.responseText);
                    },
                });
            },
            "change @ui.selectedAccount": function (e) {
                this.accountNo = $(e.currentTarget).val();

                // Reset the filter and reload the table on page 1
                this.resetDates();
                this.datatables.ajax.reload();
            },
            "click @ui.filterDates": function (e) {
                if (e) e.preventDefault();

                // Reload the table on page 1
                this.datatables.ajax.reload();
            },
        },

        resetDates: function () {
            this.ui.startDate.val();
            this.ui.endDate.val();
        },

        initialize: function () {
            var that = this;
            this.bindUIElements();

            // The history type comes from PHP as "window.historyType"
            this.historyType = window.historyType || "all";
            this.accountNo = this.ui.selectedAccount.val();

            this.cancelGuide = window.cancelGuide || null;
            this.cancelButtonContent = window.cancelButtonContent || null;

            // Initialize our 2 datepickers
            this.ui.startDatepicker.datetimepicker({
                format: "YYYY-MM-DD",
            });
            this.ui.endDatepicker.datetimepicker({
                format: "YYYY-MM-DD",
            });

            console.log("acc=" + this.accountNo);
            if (this.accountNo >= 10000) {
                // The datatables config.
                this.datatables = this.ui.datatables.DataTable({
                    searching: false,
                    ordering: false,
                    stateSave: false,
                    columns: [
                        {
                            name: "reg_datetime",
                            data: "reg_datetime",
                            type: "date",
                            searchable: false,
                        },
                        {
                            name: "currency",
                            data: "currency",
                            searchable: false,
                        },
                        {
                            name: "amount",
                            data: "amount",
                            type: "num-fmt",
                            searchable: false,
                        },
                        {
                            name: "type",
                            data: "pay_method_trans",
                            searchable: false,
                        },
                        {
                            name: "pay_method",
                            data: "type_trans",
                            searchable: false,
                        },
                        {
                            name: "status",
                            data: "status_trans",
                            searchable: false,
                            // The status color and content change depending on the status and type of the row, let's handle
                            // it using "createdCell".
                            createdCell: function (td, cellData, rowData, row, col) {
                                if (rowData.type == "withdrawal" && rowData.status == "wait") {
                                    $(td).addClass("ct_p6 cancel_withdrawal_buttons");
                                    $(td).append(
                                        ` <a href="#" class="ct_p6 cancel_withdrawal_button"><button type="button" class="btn btn-primary btn-cancel-fund">${that.cancelButtonContent}</button></a>`
                                    );
                                } else if (
                                    rowData.pay_method == "internal_transfer" &&
                                    rowData.status == "wait"
                                ) {
                                    // $(td).addClass("ct_p6 cancel_withdrawal_buttons");
                                    // $(td).append(
                                    //   ` <a href="#" class="ct_p6 cancel_withdrawal_button"><button type="button" class="btn btn-primary btn-cancel-fund">${that.cancelButtonContent}</button></a>`
                                    // );
                                } else if (
                                    rowData.status == "approved" ||
                                    rowData.status == "approve"
                                ) {
                                    $(td).addClass("c_green");
                                }
                            },
                        },
                    ],
                    deferRender: true,
                    serverSide: true, // Use server side handling
                    pageLength: 10, // nbPerPage,
                    processing: true,
                    ajax: {
                        type: "POST", // URLs are too long, so let's use POST
                        url: baseUrl + "/rest_account/fund_history",
                        data: function (d) {
                            d.history_type = that.historyType; // Required
                            d.account_no = that.accountNo; // Required
                            d.end_date = that.ui.endDate.val(); // Optional
                            d.start_date = that.ui.startDate.val(); // Optional
                        },
                    },
                    language: {
                        url:
                            baseUrl +
                            "/assets/common/common/js/libs/DataTables/languages/" +
                            lang +
                            ".json",
                    },
                    dom: '<"table-filter"l>trip', // https://datatables.net/reference/option/dom
                    initComplete: function () {
                        if (that.cancelGuide) {
                            $("div.table-filter").append(`<span>${that.cancelGuide}</span>`);
                        }
                        $("#datatables_processing").css("position", "absolute");
                    },
                });
            }
        },
    });
});